import api from './api.js'

// 消息列表
export function getSolutionConsultList(params){
    return api.get('/resource-portal/api/v1/solution/consult/proTable',params);
}

//明细
export function findSolutionConsult(uuid) {
    return api.get(`/resource-portal/api/v1/solution/consult/${uuid}`);
}



// WEBPACK FOOTER //
// ./src/utils/solutionConsult.js